import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {AudioRecordingComponent} from './audio-recording.component';
import {IonicModule} from '@ionic/angular';
import {AudioRecordItemModule} from '../audio-record-item/audio-record-item.module';
import {
    ConfirmationButtonModule
} from '../../../../../../../components/common/button/confirmation-button/confirmation-button.module';
import {ButtonModule} from '../../../../../../core/component/button/button.module';
import {CardModule} from '../../../../../../core/component/card/card.module';
import {ItemModule} from '../../../../../../core/component/item/item.module';
import {FormFieldModule} from '../../../../../../core/component/form-field/form-field.module';
import {
    LovValuesSelectFilterModule
} from '../../../../../lov/lov-value/api/component/lov-values-select-filter/lov-values-select-filter.module';
import {
    CreateUpdateDefaultModule
} from "../../../../../../core/component/create-update-default/create-update-default.module";

@NgModule({
    imports: [
        CommonModule,
        IonicModule,
        ButtonModule,
        ConfirmationButtonModule,
        AudioRecordItemModule,
        CardModule,
        ItemModule,
        AudioRecordItemModule,
        FormFieldModule,
        LovValuesSelectFilterModule,
        CreateUpdateDefaultModule,
    ],
    declarations: [
        AudioRecordingComponent
    ],
    exports: [
        AudioRecordingComponent
    ],
})
export class AudioRecordingModule {
}
